const EXPORT_FRM103_OVER_RECORD = 240
const SCHEDULE_LIST_OVER_RECORD = 240

export const Variables = {
  EXPORT_FRM103_OVER_RECORD,
  SCHEDULE_LIST_OVER_RECORD,
}
